export function getNestedProperty<T, DefaultValue = undefined>(
  object: T,
  path: string,
  defaultValue?: DefaultValue
): any {
  if (object == null) return defaultValue
  const segments = path.split('.').filter(Boolean)
  let current: any = object
  for (const segment of segments) {
    if (current == null) return defaultValue
    current = current[segment]
  }
  return current === undefined ? defaultValue : current
}

export function omitKeys<T extends Record<string, any>, K extends keyof any>(
  object: T,
  keysToOmit: K[]
): Omit<T, Extract<K, keyof T>> {
  const result: Record<string, any> = {}
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      if (!keysToOmit.includes(key as unknown as K)) {
        result[key] = (object as any)[key]
      }
    }
  }
  return result as Omit<T, Extract<K, keyof T>>
}

export function pickKeys<T extends Record<string, any>, K extends keyof T>(
  object: T,
  keysToPick: readonly K[]
): Pick<T, K> {
  const result: Partial<Pick<T, K>> = {}
  for (const key of keysToPick) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      ;(result as any)[key] = object[key]
    }
  }
  return result as Pick<T, K>
}

export function capitalizeFirstLetter(input: string): string {
  if (!input) return input
  return input.substring(0, 1).toUpperCase() + input.substring(1)
}
